/**
 * @desc 获取虚拟货币 & 法币和美元的汇率
 * @url http://yapi.cggame123.com:3001/project/95/interface/api/2396
 */

import { useGetExchangeRates } from "@/features/casino/services/rates";
import { isLoginAtom } from "@/store";
import { useAtomValue } from "jotai";

export function useCurrencyRate() {
  const isLogin = useAtomValue(isLoginAtom);
  // 获取汇率列表
  const { data: exchangeRates } = useGetExchangeRates.useNoCacheQueryHook({
    queryConfig: {
      enabled: !!isLogin,
    },
  });

  const getRate = (options: {currency: string, amount: number}) => {
    if (!exchangeRates) return null;
    // 判断是否是虚拟币
    const isCrypto = ['USDT', 'BTC'].includes(options.currency);
    if (isCrypto) {
      if (!exchangeRates.crypto_rates) return null;
      const target = exchangeRates.crypto_rates.find((item) => item.currency === options.currency);
      if (!target?.exchange_rate) return null;
      return {
        rate: target.exchange_rate,
        exchange_amount: +(target.exchange_rate) * options.amount,
      };
    }
    const fiatRates = exchangeRates.fiat_rates?.filter((item) => +item?.is_fiat === 1);
    if (!fiatRates) return null;
    const target = fiatRates.find((item) => item.currency === options.currency);
    if (!target?.exchange_rate) return null;
    return {
      rate: target.exchange_rate,
      exchange_amount: +(target.exchange_rate) * options.amount,
    }
  }

  return {
    getRate,
  }
}